"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import get from "lodash/get"
import useSessionAttributes from "../lib/auth/useSessionAttributes"
import useAccountResource from "./useAccountResource"

export type MeData = {
  providerId?: number | null
  userId?: number | null
  authRole?: string | null
  photoUrl?: string | null
  firstName?: string | null
  lastName?: string | null
  /** Legacy single-field preferred name — no longer displayed. */
  preferredName?: string | null
  preferredFirstName?: string | null
  preferredLastName?: string | null
  phone?: string | null
  email?: string | null
  isFullyOnboarded?: boolean | null
  profileComplete?: boolean | null
  profilePendingPublication?: boolean | null
}

export type UseGetMeState = {
  loading: boolean
  error: unknown
  me: MeData | null
  photoUrl: string | null
  firstName: string | null
  lastName: string | null
  preferredName: string | null
  preferredFirstName: string | null
  preferredLastName: string | null
  userId: number | null
  providerId: number | null
  authRole: string | null
  phone: string | null
  email: string | null
  orgId: number | string | null
  isFullyOnboarded: boolean
  profileComplete: boolean
  profilePendingPublication: boolean
}

export default function useGetMe(options?: {
  enabled?: boolean
}): [UseGetMeState, { refetchMe: () => Promise<void> }] {
  // Session is already hydrated into <SessionProvider> from the server layout,
  // so useSession() reads it from context with no network round-trip (unlike
  // the previous getSession() call, which hit /api/auth/session).
  const { isAuthenticated, isInitializing, orgId, resourceScope } =
    useSessionAttributes()

  const enabled = options?.enabled !== false && isAuthenticated
  const {
    data,
    error,
    loading: fetching,
    refetch: fetchData,
  } = useAccountResource<{ me?: MeData }>(
    enabled ? "/edge/get-me" : null,
    resourceScope,
  )
  const loading = options?.enabled !== false && (isInitializing || fetching)
  const me = enabled ? (data?.me ?? null) : null
  const providerId = me == null ? null : (get(me, "providerId") ?? null)
  const userId = me == null ? null : (get(me, "userId") ?? null)
  const authRole = me == null ? null : (get(me, "authRole") ?? null)
  const photoUrl = me == null ? null : (get(me, "photoUrl") ?? null)
  const firstName = me == null ? null : (get(me, "firstName") ?? null)
  const lastName = me == null ? null : (get(me, "lastName") ?? null)
  const preferredName = me == null ? null : (get(me, "preferredName") ?? null)
  const preferredFirstName =
    me == null ? null : (get(me, "preferredFirstName") ?? null)
  const preferredLastName =
    me == null ? null : (get(me, "preferredLastName") ?? null)
  const phone = me == null ? null : (get(me, "phone") ?? null)
  const email = me == null ? null : (get(me, "email") ?? null)
  const isFullyOnboarded = Boolean(get(me, "isFullyOnboarded", false))
  const profileComplete = Boolean(get(me, "profileComplete", false))
  const profilePendingPublication = Boolean(
    get(me, "profilePendingPublication", false),
  )

  return [
    {
      loading,
      error,
      me,
      photoUrl,
      firstName,
      lastName,
      preferredName,
      preferredFirstName,
      preferredLastName,
      userId,
      providerId,
      authRole,
      phone,
      email,
      orgId: enabled ? orgId : null,
      isFullyOnboarded,
      profileComplete,
      profilePendingPublication,
    },
    {
      refetchMe: fetchData,
    },
  ]
}
